import { FetchingDiv } from "@shared/ui/fetching-div/fetching-div";
import { useNavigate, useParams } from "react-router-dom"
import s from './teacher-profile.module.scss'
import { useTeacher } from "@entities/teacher/api/useTeacher";
import { TeacherStat } from "@widgets/student/ui/teacher-profile/ui/teacher-stat/teacher-stat";
import { TeacherProfileCard } from "@widgets/student/ui/teacher-profile/ui/teacher-profile-card/teacher-profile-card";
import { TeacherAbout } from "@widgets/student/ui/teacher-profile/ui/teacher-about/teacher-about";
import { TeacherEducation } from "@widgets/student/ui/teacher-profile/ui/teacher-education/teacher-education";
import { TeacherReviews } from "@widgets/student/ui/teacher-profile/ui/teacher-reviews/teacher-reviews";
import { VideoPlayer } from "@widgets/student/ui/teacher-profile/ui/video-player/video-player";
import { getCDNPath } from "@utils/lib/getCDNpath";
import { getFullName } from "@utils/lib/getFullname";
import { TeacherSellCard } from "@widgets/student/ui/teacher-profile/ui/teacher-sell-card/teacher-sell-card";
import { TeacherPacks } from "@widgets/student/ui/teacher-profile/ui/teacher-packs/teacher-packs";
import { Slider } from "@features/student/teacher/ui/teacher-modal/slider"
import { StartChatButton } from "@features/messanger/start-chat";

export const TeacherProfile = () => {

    const { id } = useParams();
    const navigate = useNavigate()
		
    const { data: teacher, isFetching } = useTeacher(id)
		
    const hasMedia = (teacher?.photos?.length > 0) || !!teacher?.video_presentation

    return (
        <div className={s.wrapper}>
            <FetchingDiv isFetching={isFetching} className={s.container}>
                <div className={s.leftColumn}>
                    <TeacherProfileCard teacher={teacher}/>
                    <TeacherStat teacher={teacher}/>
                    <TeacherAbout teacher={teacher}/>
                    <TeacherEducation teacher={teacher}/>
									<div>{hasMedia && <Slider teacher={teacher} fullWidth/>}</div>
                    <TeacherReviews teacher={teacher}/>
                </div>
                <div className={s.rightColumn}>
                    <StartChatButton teacherId={teacher?.id} className={s.startChatButton}/>
                    <VideoPlayer
                        src={getCDNPath(teacher?.video_presentation)}
                        poster={teacher?.video_presentation_preview ? getCDNPath(teacher.video_presentation_preview) : null}
                        alt={getFullName(teacher)}
                        hidden={!teacher?.video_presentation}
                    />
                    <TeacherSellCard teacher={teacher} rating={teacher?.rating}/>
                    {!teacher?.trial_enabled && (
                        <TeacherPacks
                            teacher={id}
                            singleLessonPrice={teacher?.grade?.price}
                            showEmpty
                            onSelect={(pack) => navigate(`/teacher/packs/${id}?pack=${pack?.id}`)}
                        />
                    )}
                </div>
            </FetchingDiv>
        </div>
    )
}
